webpackJsonp([93],{

/***/ "77+n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ijdq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            user: {},
            storeId: 0,
            show: false
        };
    },
    created: function created() {
        /*this.storeId = sessionStorage.getItem('storeId')
        if (this.storeId){
            this.show = true;
        }else {
            var screenWidth = window.screen.width;
            if (screenWidth > 800) {
                this.$router.push('/admin/login');
            } else {
                this.$router.push('/login');
            }
         }*/
    }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_reset_css__ = __webpack_require__("zZiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_index_scss__ = __webpack_require__("yh13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_dialog__ = __webpack_require__("6xqC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vant_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_base64__ = __webpack_require__("xrTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_js_cookie__);



var _this2 = this;













__webpack_require__("hKoQ").polyfill();
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vant_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, { size: 'medium' });
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

if (false) {
    Vue.prototype.apiUrl = 'http://api.mall.lypinyue.cyy';
    Vue.prototype.domainUrl = 'http://localhost:8083';
    Vue.prototype.mobileDomain = 'http://m.mall.lypinyue.cyy';
    Vue.prototype.loginDomain = 'http://localhost:8081';
    Vue.prototype.pcDomainUrl = 'http://www.c2cmall.cyy';
    Vue.prototype.pcLoginUrl = 'http://www.c2cmall.cyy/?app=member&act=login&ret_url=' + encodeURIComponent(location.href);
    axios.defaults.baseURL = 'http://api.mall.lypinyue.cyy';
} else {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.pcDomainUrl = 'http://mall.lypinyue.com';
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.pcLoginUrl = 'http://mall.lypinyue.com/?app=member&act=login&ret_url=' + encodeURIComponent(location.href);
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.apiUrl = 'https://api.mall.lypinyue.com';
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.domainUrl = 'http://admin.store.shangduoke.com';
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.mobileDomain = 'http://m.mall.lypinyue.com';
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.loginDomain = 'https://m.mall.lypinyue.com';
    __WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.baseURL = 'https://api.mall.lypinyue.com';
}

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_9_axios___default.a;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$http.defaults.withCredentials = true;

//http request 拦截器
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.request.use(function (config) {
    if (__WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.get('access_token')) {
        var access_token = __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.get('access_token'); // 判断是否存在token，如果存在的话，则每个http header都加上token
        var password = '';
        //config.headers.Authorization = 'Basic ' + Base64.encode(access_token+':'+password);
        config.headers.Authorization = 'Bearer ' + access_token;
    }
    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
});
var _this = this;
// http response 拦截器
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                //this.$store.commit('setToken',{access_token:null});
                //sessionStorage.removeItem('access_token')
                //console.log(Vue.prototype.loginDomain)
                var screenWidth = window.screen.width;
                if (screenWidth > 800) {
                    //location.href = Vue.prototype.pcLoginUrl;
                    _this2.$router.push('/login');
                } else {
                    location.href = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.loginDomain + '/jz/#/login?redirectUrl=' + encodeURIComponent(location.href);
                }
        }
    }
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error); // 返回接口返回的错误信息
});

var store = new __WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* default */].Store({
    state: {
        access_token: '',
        userId: {},
        storeId: {},
        breadcrumb: []
    },
    mutations: {
        setToken: function setToken(state, payload) {
            state.access_token = payload.access_token;
        },
        setUser: function setUser(state, data) {
            state.userId = data.user_id;
            __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.set('user_id', data.user_id);
            __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.set('access_token', data.access_token);
        },
        setStore: function setStore(state, data) {
            state.storeId = data.id;
            //sessionStorage.setItem('store',JSON.stringify(data))
            __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.set('storeId', data.id);
        },
        setBreadcrumb: function setBreadcrumb(state, data) {
            state.breadcrumb = data;
            __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.set('breadcrumb', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        }
    }
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({ // eslint-disable-line
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: store,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */]);
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/', name: 'home', component: function component() {
        return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "wUZA"));
    } }, {
    path: '/admin',
    name: 'admin',
    component: function component() {
        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "QxDH"));
    },
    children: [{ path: 'home', component: function component() {
            return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "NU4r"));
        } }, {
        path: 'product/list',
        component: function component() {
            return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "zO4u"));
        }
    }, {
        path: 'product/edit',
        component: function component() {
            return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "QyKU"));
        }
    }, {
        path: 'order/list',
        component: function component() {
            return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "vS6c"));
        }
    }, {
        path: 'order/view',
        component: function component() {
            return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "ispf"));
        }
    }, {
        path: 'order/delivery',
        component: function component() {
            return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "41dw"));
        }
    }, {
        path: 'store/edit',
        component: function component() {
            return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "sP75"));
        }
    }, {
        path: 'money/index',
        component: function component() {
            return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "9NPG"));
        }
    }, {
        path: 'money/withdraw',
        component: function component() {
            return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "cyPA"));
        }
    }, {
        path: 'money/bank',
        component: function component() {
            return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "Piav"));
        }
    }, { path: 'cashier', component: function component() {
            return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "2EJV"));
        } }, { path: 'stock/in', component: function component() {
            return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "v/af"));
        } }, { path: 'stock/out', component: function component() {
            return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "onMi"));
        } }, { path: 'booking/list', component: function component() {
            return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "+8pM"));
        } }, { path: 'booking/item-create', component: function component() {
            return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "/q63"));
        } }, { path: 'booking/item-list', component: function component() {
            return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "bWPL"));
        } }, { path: 'member/list', component: function component() {
            return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "MNaF"));
        } }, { path: 'member/edit', component: function component() {
            return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "9a8a"));
        } }, { path: 'member/add-card', component: function component() {
            return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "KzO6"));
        } }, { path: 'member/detail', component: function component() {
            return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "EJSO"));
        } }, { path: 'member/recharge', component: function component() {
            return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "ClBv"));
        } }, { path: 'category/list', component: function component() {
            return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "SqWL"));
        } }, { path: 'category/edit', component: function component() {
            return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "Y08p"));
        } }, { path: 'setting/product-unit', component: function component() {
            return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "qlzy"));
        } }, { path: 'statistic/customer', component: function component() {
            return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "YVtJ"));
        } }, { path: 'statistic/customer-consume', component: function component() {
            return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "XAKd"));
        } }, { path: 'statistic/customer-recharge', component: function component() {
            return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "HuIc"));
        } }]
}, { path: '/admin/login', component: function component() {
        return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "s3nr"));
    } }, { path: '/admin/reg', component: function component() {
        return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "BI3S"));
    } }, { path: '/admin/find-password', component: function component() {
        return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "SJb1"));
    } }, { path: '/mobile', component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "7PMi"));
    } }, { path: '/mobile/index', component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "7PMi"));
    } }, { path: '/mobile/store/index', component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "4TJH"));
    } }, {
    path: '/mobile/store/edit',
    component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "zdlY"));
    }
}, {
    path: '/mobile/product/list',
    component: function component() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "M74g"));
    }
}, {
    path: '/mobile/product/create',
    component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "HqII"));
    }
}, {
    path: '/mobile/order/list',
    component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "Z1R7"));
    }
}, {
    path: '/mobile/member/index',
    component: function component() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "/YoV"));
    }
}, {
    path: '/mobile/money/index',
    component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "gVe4"));
    }
}, { path: '/mobile/money/recharge', component: function component() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "APR4"));
    } }, {
    path: '/mobile/money/withdraw',
    component: function component() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "sNwm"));
    }
}, { path: '/mobile/money/adjustment', component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "j6SF"));
    } }, {
    path: '/mobile/market/index',
    component: function component() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "b43p"));
    }
}, {
    path: '/mobile/statistic/income',
    component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "nB5g"));
    }
}, {
    path: '/mobile/statistic/flow',
    component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "CmeK"));
    }
}, {
    path: '/mobile/statistic/order',
    component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "7ctE"));
    }
}, {
    path: '/mobile/statistic/customer',
    component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "mZWy"));
    }
}, {
    path: '/mobile/order/view',
    component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "r3WD"));
    }
}, {
    path: '/mobile/member/search',
    component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "2USn"));
    }
}, {
    path: '/mobile/group/index',
    component: function component() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "TL3d"));
    }
}, {
    path: '/mobile/fenxiao/index',
    component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "nyOz"));
    }

}, {
    path: '/mobile/fenxiao/setting',
    component: function component() {
        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "f1mR"));
    }
}, {
    path: '/mobile/fenxiao/order',
    component: function component() {
        return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "VenD"));
    }
}, {
    path: '/mobile/fenxiao/rank',
    component: function component() {
        return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "iXKX"));
    }
}, {
    path: '/mobile/fenxiao/withdraw',
    component: function component() {
        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "Si5i"));
    }
}, { path: '/mobile/booking/index', component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "Lvhs"));
    } }, { path: '/mobile/booking/add', component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "byB4"));
    } }, { path: '/mobile/member/add', component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "6XdG"));
    } }, { path: '/mobile/member/detail', component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "FDd7"));
    } }, { path: '/mobile/member/consume-detail', component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "DAiB"));
    } }, { path: '/mobile/member/card-index', component: function component() {
        return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "UJ52"));
    } }, { path: '/mobile/member/card-bill', component: function component() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "7YLV"));
    } }, { path: '/mobile/member/integral-adjust', component: function component() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "peCZ"));
    } }, { path: '/mobile/member/integral-exchange', component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "sZgs"));
    } }, { path: '/mobile/card/add', component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "SWYy"));
    } }, { path: '/mobile/card/list', component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "Lz7j"));
    } }, { path: '/mobile/card/member-add', component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "2lfj"));
    } }, { path: '/mobile/cashier', component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "lM2Z"));
    } }, { path: '/mobile/statistic/index', component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "rrm8"));
    } }, { path: '/mobile/statistic/recharge', component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "uMff"));
    } }, { path: '/mobile/category/list', component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "LQgR"));
    } }, { path: '/mobile/category/edit', component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "jLg1"));
    } }, { path: '/mobile/booking/item-add', component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "+Pm6"));
    } }, { path: '/mobile/booking/item-index', component: function component() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "LcLK"));
    } }, { path: '/mobile/customer/index', component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "O8Mn"));
    } }, { path: '/mobile/customer/card-detail', component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "e+RN"));
    } }, { path: '/mobile/customer/bill', component: function component() {
        return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "tfq0"));
    } }, { path: '/mobile/customer/my', component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "opbt"));
    } }, { path: '/mobile/statistic/store-operate', component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "0RzW"));
    } }, { path: '/mobile/statistic/consume', component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "7fRk"));
    } }, { path: '/mobile/statistic/product-consume', component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "//F9"));
    } }, { path: '/mobile/statistic/member-stat', component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "lrhY"));
    } }, { path: '/mobile/statistic/integral-stat', component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "Y1eT"));
    } }, { path: '/mobile/statistic/reg-stat', component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "vBnk"));
    } }, { path: '/mobile/stock/index', component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "07Xr"));
    } }, { path: '/mobile/stock/in', component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "+t0Y"));
    } }, { path: '/mobile/stock/out', component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "WWFV"));
    } }, { path: '/mobile/stock/detail', component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "kc0R"));
    } }, { path: '/mobile/login', component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "IKIj"));
    } }, { path: '/mobile/reg', component: function component() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "C3ZP"));
    } }, { path: '/mobile/find-password', component: function component() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "F/iw"));
    } }];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'hash',
    base: __dirname,
    routes: routes
});

router.beforeEach(function (to, from, next) {
    if (to.query.access_token && to.query.user_id) {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('access_token', to.query.access_token, { expires: 7 });
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('user_id', to.query.user_id, { expires: 7 });
        next();
    } else {
        var access_token = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('access_token');
        //如果access_token不存在
        if (!access_token) {
            var screenWidth = window.screen.width;
            if (screenWidth > 800) {
                if (to.path == '/admin/login' || to.path == '/admin/reg' || to.path == '/admin/find-password') {
                    next();
                } else {
                    //电脑端
                    next({ path: '/admin/login' });
                }
            } else {
                if (to.path == '/mobile/login' || to.path == '/mobile/reg' || to.path == '/mobile/find-password') {
                    next();
                } else {
                    //手机端
                    next({ path: '/mobile/login?redirectUrl=' + encodeURIComponent(location.href) });
                }
            }
        } else {
            //access_token存在
            next();
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("Ijdq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd6224a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("nDFe");
function injectStyle (ssrContext) {
  __webpack_require__("77+n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd6224a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nDFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-page"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yh13":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zZiL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.af10f999028a53183880.js